import { ArrowRightRounded, CheckCircleRounded } from '@mui/icons-material';
import { Alert, FormHelperText, Snackbar } from '@mui/material';
import { Button, Input, Modal as ModalDrop } from 'antd';
import useIsTouchDevice from 'components/hooks/useTouchDevice';
import Loading from 'components/Loading';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import config from 'config';
import { get, uniq } from "lodash";
import React, { useEffect, useRef, useState, Suspense } from 'react';
import { useDispatch } from 'react-redux';

const QrReader = React.lazy(() => import('react-qr-reader'));
import { useBookOrder } from 'store/books/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { handleGetClassActiveGameSession } from 'store/game_session/thunks';
import { useOneGameModal, usePlayModal } from 'store/one_game/selectors';
import { handleAutologinOneGame, handleGameBySessionId } from "store/one_game/thunks";
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import { IGameHome7, IGameLogo } from "utils/assets/images";
import OneGameButtonPng from "../../utils/assets/images/1Game-button.png";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 20px;
`;
const Content = styled.div`
      display: flex;
      justify-content:center;
`;

const ScannerContainer = styled.div`
  text-align: center;
  margin: 20px;
  margin-bottom: 10px;
`;

const ScanButton = styled.button`
  padding: 10px 20px;
//   margin-bottom: 20px;
  cursor: pointer;
  width: 100%;
  background-color: #012B70;
  color: white;
  border: none;
  border-radius: 5px;
  margin-top:20px;
  margin-bottom:20px;
  &:hover {
    background-color: #012B70;
  }
`;

const ScannerArea = styled.div`
  max-width: 400px;
  margin: auto;
`;

const ORdiv = styled.div`
display: flex;
text-align: center;
width: 100%;
justify-content: center;
font-weight: bold;
`
const Label = styled.div`
  font-size:14px;
  font-weight: bold;
  text-align: left;
`;
const InoputBox = styled(Input)`
    width:100%;
    border-radius: 30px;
    border:1px solid #002d74;
`;
const Form = styled.form`
    algin-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    width: 100%;
`;

const JoinButton = styled.a`
    &:hover {
       opacity: 0.8;
    }
`;


const Cover = styled.div`
    width: 100%;   
    height: 230px;
    background-image: url(${p => p.src ? p.src : IGameHome7});
    background-size: 100%; 
    background-position: center; 
    background-repeat: no-repeat; 
`;
const CardWrapper = styled.div`
display: flex;
justify-content: center;
`;
const CardContent = styled.div`
      display: flex;
      justify-content:center;
`;
const CardJoinButton = styled.a`
    &:hover {
       opacity: 0.8;
    }
`;
const CardInoputBox = styled(Input)`
    width:100%;
    border-radius: 30px;
    border:1px solid #002d74;
`;
const CardForm = styled.form`
    algin-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    width: 100%;
`;

const IdeaImage = styled.img`
    height: 40px;
    margin-bottom: 5px;
    border-radius: 20px;
`;


const ButtonWrapper = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background: transparent;
  z-index: 11;
  -webkit-transition: all 1s ease 0s;
  transition: all 1s ease 0s;
  cursor: pointer;
}
`;

const configServer = import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'prod' : 'dev';

const GameCard = ({ item, joinLoader, handleRedirectOnegame }) => {
    // const image_url = item && item.media_urls ? item.media_urls.image : IGameHome7
    const image_url = item && item?.media_urls?.image ? item?.media_urls?.image : IGameHome7
    return (<CardWrapper className='aiGmMdl'>
        <div className='myUnitsGm' style={{ overflow: "hidden", border: "1px solid", minWidth: 200 }}>
            <div className='myUnitsBnr'>
                <Cover src={image_url} />
            </div>
            <div className='myUnitsTxt'>
                <div className='myUnitsInfo'>
                    <label>{item.display_name || 'Untitled'}</label>
                    <p>{item?.category?.category_name || "--"}</p>
                    <span>Pg. {item?.sub_category?.category_name || item?.sub_category?.reference_id || '--'}</span>
                </div>
                {/* {!!errorMessage ? <FormHelperText error>{errorMessage}</FormHelperText> : null} */}
                <div className='myUnitsBtns'>
                    <JoinButton onClick={handleRedirectOnegame} className='BtnsStart'>
                        <ArrowRightRounded />{joinLoader ? <Loading size={16} white /> : "Join"}
                    </JoinButton>
                </div>
                <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
            </div>
        </div>
    </CardWrapper>)
}

// function QRCodeScanner({ onScan , joinLoader  , opened  , gameloader,setScannerEnabled,scannerEnabled }) {
//   const [track, setTrack] = useState(null);
//   const [zoom, setZoom] = useState(1);
//   const [maxZoom, setMaxZoom] = useState(null);
  
//     useEffect(()=>{
//         setScannerEnabled(false)
//     },[opened])

//     const handleZoomChange = (e) => {
//       const newZoom = Number(e.target.value);
//       setZoom(newZoom);
//       if (track) {
//           track.applyConstraints({ advanced: [{ zoom: newZoom }] }).catch(console.error);
//       }
//     };

//     const handleScan = data => {
//         if (data) {
//             setScannerEnabled(false);
//             onScan(data); 
//         }
//     };

//     const handleError = err => {
//         setScannerEnabled(false);
//     };

//     return (
//         <ScannerContainer>
//             <ScanButton disabled={joinLoader} onClick={() => setScannerEnabled(!scannerEnabled)}>{gameloader?<Loading size={14} white/>:null} {scannerEnabled ? "Stop game using" : "Start Game using"}  QR</ScanButton>
//             {scannerEnabled && (
//               <>
//                 <QrReader
//                     delay={300}
//                     onError={handleError}
//                     onResult={handleScan}
//                     constraints={{facingMode:"environment"}}
//                     style={{ width: '100%' }}
//                 />
//                 {/* {maxZoom && ( */}
//                   <div style={{ marginTop: 10 }}>
//                       <label>Zoom: {zoom.toFixed(1)}x</label>
//                       <input
//                           type="range"
//                           min="1"
//                           max={maxZoom}
//                           step="0.1"
//                           value={zoom}
//                           onChange={handleZoomChange}
//                           style={{ width: '100%' }}
//                       />
//                   </div>
//               {/* )} */}
//               </>
//             )}
//         </ScannerContainer>
//     );
// }

function QRCodeScanner({ onScan , joinLoader  , opened  , gameloader,setScannerEnabled,scannerEnabled }) {
  const videoRef = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [maxZoom, setMaxZoom] = useState(1);
  const trackRef = useRef(null);
  const zoomTimeoutRef = useRef(null);

  const handleZoomChange = (e) => {
    const newZoom = parseFloat(e.target.value);
    setZoomLevel(newZoom);
  
    if (zoomTimeoutRef.current) clearTimeout(zoomTimeoutRef.current);
  
    zoomTimeoutRef.current = setTimeout(() => {
      if (trackRef.current) {
        trackRef.current.applyConstraints({
          advanced: [{ zoom: newZoom }]
        });
      }
    }, 200); // Debounce time: adjust if needed
  };

  const handleScan = data => {
      if (data) {
          setScannerEnabled(false);
          onScan(data); 
      }
  };

  const handleToggleScanner = () => {
    setScannerEnabled(!scannerEnabled);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const video = videoRef.current?.querySelector('video');
      if (video && video.srcObject) {
        const [track] = video.srcObject.getVideoTracks();
        trackRef.current = track;

        const capabilities = track.getCapabilities();
        if (capabilities.zoom) {
          setMaxZoom(capabilities.zoom.max);
          setZoomLevel(capabilities.zoom.min || 1);

          // Apply initial zoom
          track.applyConstraints({ advanced: [{ zoom: capabilities.zoom.min || 1 }] });
        }

        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <ScanButton disabled={joinLoader} onClick={handleToggleScanner}>{gameloader?<Loading size={14} white/>:null} {scannerEnabled ? "Stop game using" : "Start Game using"}  QR</ScanButton>
      {scannerEnabled && (
        <>
      <div ref={videoRef} style={{ width: '100%' }}>
        <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px' }}>Loading QR Scanner...</div>}>
          <QrReader
            delay={300}
            onError={(err) => console.error("QR Reader error:", err)}
            onScan={handleScan}
            facingMode="environment"
            style={{ width: '100%' }}
          />
        </Suspense>
      </div>

      {maxZoom > 1 && (
        <div style={{ marginTop: '10px', justifyContent: 'center', display: 'flex' }}>
          <label style={{ marginRight: '5px' }}>Zoom:</label>
          <input
            type="range"
            min="1"
            max={maxZoom}
            step="0.1"
            value={zoomLevel}
            onChange={handleZoomChange}
          />
        </div>
      )}
    </>
    )}
    </div>
  );
}


const OneGameJoinModalButton = ({ imageStyle, oneGameModalVisible, setOneGameModalVisible }) => {
    const showAlert = useAlert();
    const isTouchDevice = useIsTouchDevice();
    const [viewModal, setModal] = useState(false);
    const [scannerEnabled, setScannerEnabled] = useState(false);
    const [code, setCode] = useState('');
    const currentUser = useCurrentUser();
    const [joinLoader,setJoinLoader] = useState(false);
    const dispatch = useDispatch();
    const currentClass = useCurrentClass();
    const {  openOnegameModal  } = useOneGameModal()
    const [errorText,setErrorText] = useState('');
    const [fechedGame,setFechedGame] = useState({});
    const [gameloader,setgameloader] = useState(false);
    const { playGameModal, closePlayerModal,openPlayerModal } = usePlayModal();
    const [loaderForOpenStudent,setLoaderForOpenStudent] = useState(false);
    const bookOrder = useBookOrder()
      const [alert, setAlert] = useState({
        open: false,
        message: "",
      });


    useEffect(()=>{
        setFechedGame({});
    },[viewModal])

    const onClose = () => {
        setScannerEnabled(false);
        setModal(false);
        setFechedGame({});
        if (setOneGameModalVisible) {
            setOneGameModalVisible(false)
        }
    }
    const handleScanResult = data => {
        if(data){
            try {
            const url = new  URLSearchParams(data);
            if(url.get("session_id")){
                handleCode(url.get("session_id"))
            }else{
                setErrorText(`Invalid QR Code session id not found`) 
                }
            } catch (error) {
                console.error("Error parsing QR code:", error);
                setErrorText(`Invalid QR Code: could not parse URL parameters`);
            }
        }else{
            setErrorText(`Invalid QR Code data has no text field`); 
        }
    };
    const handleCode = async (session_id) => {
      setgameloader(true);
      try {
        const listGameData = await dispatch(
          handleGameBySessionId(currentUser.id, session_id)
        );
        const gameSession = get(listGameData, "game_session", "") ?? {};
        if (gameSession?.class_id !== currentClass?.id) {
          showAlert("You are not in my class", "error");
          return;
        }
        if (listGameData && listGameData.game_id) {
          setFechedGame(listGameData);
        } else {
          setFechedGame({});
        }
      } catch (error) {
        console.log(error);
      } finally {
        setgameloader(false);
      }
    };
  const getBooks = () => {
    const books = [];
    (currentClass.books_group || []).forEach((key) => {
      bookOrder.forEach((order) => {
        if (order.key === key) {
          books.push(...order.order);
        }
      })
    })
    return uniq(books);
  }
    const getClassMetadata = () => {
        return ({
            class_id:currentClass.id,
            class_display_name:currentClass.displayName,
            books:getBooks()
        })
     }
    const handleRedirectOnegame = async (e) => {
        if(e){
            e.preventDefault();
        }
        if(joinLoader||Object.keys(fechedGame).length==0) return;
        setErrorText('')
        setJoinLoader(true)
        const listGameData = fechedGame.game_session;
        if(listGameData&&listGameData.id){
            if(listGameData.status!='started'){
                const data = await dispatch(handleAutologinOneGame(currentUser.id, currentClass.id, { action: 'join_game', game_id : listGameData.game_id , session_id:listGameData.id , session_code:listGameData.pin_code , class_info:getClassMetadata()  }));
                if (data && data.key) {
                    let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
                    if (config.is_local) {
                        uri = `http://${window.location.hostname}:3011/session_auth`
                    } else if (configServer === 'prod') {
                        uri = 'https://1game.nosotrosonline.com/session_auth'
                    }
                    const url = `${uri}?key=${data.key}`
                    openOnegameModal(url)
                    setModal(false);
                    setCode('')
                }
            }else{
                setErrorText("Game already started, unable to join")
            }
          
            onClose()
            setCode('')
        }else{
            setErrorText("Access denied")
        }
        setJoinLoader(false)
    }

     const fetchActiveGameSession = async () => {
       if (currentClass?.id && currentUser?.role === "student") {
         try {
           const sessionId = localStorage.getItem("game_session_id") || "";
           
           // First check if there's an active session for this user in this class
         const session_data = await dispatch(
           handleGetClassActiveGameSession(
             currentClass.id,
             currentUser.id,
             sessionId
           )
         );
          if (session_data?.session_id && session_data?.status !== "ended") {
             // Verify this session belongs to current class
             if (session_data.class_id === currentClass.id) {
           openPlayerModal(session_data);
         }else{
               showAlert('No active game in this class', "error");
             }
           } else{
             showAlert('No active game', "error");
           }
         } catch (error) {
           console.error("Error fetching active game session:", error);
           showAlert('Error checking active games', "error");
         }
       }
     };

    const openNotificationModal = async () => {
      if(loaderForOpenStudent) return;
      setLoaderForOpenStudent(true);
      try {
        await fetchActiveGameSession();
      } catch (error) {
        console.log(error);
      } finally {
        setLoaderForOpenStudent(false);
        onClose();
      }
    };
    
    const handleCloseAlert = () => {
        setAlert({
          open: false,
          message: "",
        });
      };

    const handlerOpen = () => {
        if(isTouchDevice){
            setModal(true);
            return;
        }
        openNotificationModal();
    }

    
    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={alert.open}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
                >
                <Alert onClose={handleCloseAlert} severity="error">
                    <strong>ALERT:</strong> {alert.message}
                </Alert>
            </Snackbar>
            <ModalDrop
                open={viewModal || oneGameModalVisible}
                onCancel={onClose}
                destroyOnHidden={true}
                className={`scenarioMdlWrap`}
            >
                <div>
                    <div className='oneGmPopup vocOrGame' style={{marginLeft: "0px"}}>
                        <Button className='gmPopupBtn oneGmeLogo'>
                            <img src={IGameLogo} alt="" />
                        </Button>
                    </div>
                    <Wrapper className='aiGmMdl'>
                        {!!errorText ? <FormHelperText error>{errorText}</FormHelperText> : null}
                        {(viewModal || oneGameModalVisible) && 
                            <QRCodeScanner 
                                onScan={handleScanResult} 
                                joinLoader={joinLoader} 
                                opened={viewModal || oneGameModalVisible} 
                                gameloader={gameloader} 
                                scannerEnabled={scannerEnabled} 
                                setScannerEnabled={setScannerEnabled}
                                hasGameData={Object.keys(fechedGame).length > 0}
                            />
                        }
                        
                        {Object.keys(fechedGame).length > 0 && !scannerEnabled ? <GameCard item={fechedGame} joinLoader={joinLoader} handleRedirectOnegame={handleRedirectOnegame} /> : null}

                        <div style={{ display: "flex", alignItems: "center", width: "100%", marginTop: "10px", marginBottom: "10px",}}>
                            <hr style={{ flexGrow: 1, border: "none", height: "1px", backgroundColor: "#000" }} />
                            <p style={{ margin: "0 10px", fontWeight: "bold" }}>OR</p>
                            <hr style={{ flexGrow: 1, border: "none", height: "1px", backgroundColor: "#000" }} />
                        </div>
                        
                        <StyledButton className='gap-10px' onClick={openNotificationModal}>
                            {loaderForOpenStudent ? <Loading size={16} white={true} /> : null}
                            Join Active Game   
                        </StyledButton>
                    </Wrapper>
                </div>
            </ModalDrop>
            <ButtonWrapper onClick={handlerOpen}>
                <IdeaImage src={OneGameButtonPng} alt="1Game" title="1Game" />
            </ButtonWrapper>
        </div>
    );
};



export default OneGameJoinModalButton;

const StyledButton = styled.button`
  text-align: center;
  display: flex;
  align-items:center;
  justify-content: center;
  padding: 10px 20px;
  margin-bottom: 20px;
  cursor: pointer;
  background-color: #03989e;
  color: white;
  border: none;
  border-radius: 5px;
  &:hover {
    background-color: #03989e;
  }
`;
